import QrAllPrintContent from "../../../../LogisticsManagement/InBound/QrAllPrintContent";
import { LoadingButton } from "@mui/lab";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { fetchDetailsInBound } from "../../../../../slices/inbound";
import NoDataCard from "../../../../../../components/no-data-card";
import SkeletonLoader from "../../../../../../utilites/SkeltonLoader";
import { Box } from "@mui/material";
import { selectFollowCycle } from "../../../../../slices/common";
import {
  selectDropDownDataMaster,
  fetchManufecturingButtonDropDown,
} from "../../../../../slices/customMaster";
import { transformDataWithFiles } from "../../../../../../pages/appointment-details/common-pre-screen/common";
import {
  SampleTypes,
  ALCDelcarationOption,
  DispatchModes,
  confirmationOptions,
  confirmationOptions1,
  BloodNotUsed,
} from "../../../../../../pages/appointment-details/common-in-bound/common";
import { selectAllInitialSteps } from "../../../../../slices/common";
import { capitalizeWords, parseToDate } from "../../../../../../utils/utils";
import {
  fetchAllActiveDeliveryPartners,
  selectDeliveryActivePartnersAll,
} from "../../../../../slices/deliveryPartners";

const DownloadInboundForm = ({ patientData }) => {
  const [allPrintData, setAllPrintData] = useState({});
  const [inBoundForm, setInBoundForm] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const currentCycle = useSelector(selectFollowCycle);
  const LogisticsPartners = useSelector(selectDeliveryActivePartnersAll) || [];
  const isCommercial = patientData?.phase_type?.toLowerCase() === "commercial";
  const isTrial = patientData?.phase_type?.toLowerCase() === "trial";
  const phaseLabels = {
    patient: isCommercial ? "Patient " : "Subject ",
    hospital: isCommercial ? "Hospital " : "Site ",
    investigator: isCommercial ? "HCP" : "Principal Investigator",
  };

  const [enableForm1, setEnableForm1] = useState(false);
  const [enableForm2, setEnableForm2] = useState(false);
  const [enableForm3, setEnableForm3] = useState(false);
  const [enableForm4, setEnableForm4] = useState(false);

  // const { state } = useLocation();
  // const patientData = state?.row;
  // const inBoundId = patientData?.inbond_patient?.id;
  // const feasibilityId = patientData?.feasibility_assessments?.id;
  const printTimeoutAllRef = useRef(null);
  const printContentAllRef = useRef(null);
  const now = new Date();
  const timeString = now.toTimeString().slice(0, 5); // "HH:MM"
  const equipmentOptions = useSelector(selectDropDownDataMaster("equipment"));

  const initialSteps = useSelector(selectAllInitialSteps);

  useEffect(() => {
    dispatch(fetchManufecturingButtonDropDown("equipment"));
    dispatch(fetchAllActiveDeliveryPartners());
  }, []);

  useEffect(() => {
    if (initialSteps?.length > 0) {
      const apheresisStatus = initialSteps?.find(
        (op) => op.slug === "apheresis",
      )?.status;
      const lsmStatus = initialSteps?.find(
        (op) => op.slug === "lsm-received-bmr",
      )?.status;
      const verifyLSM = initialSteps?.find(
        (op) => op.slug === "lsm-qualified",
      )?.status;
      setEnableForm1(apheresisStatus >= 1);
      setEnableForm4(lsmStatus === 2);
      setEnableForm2(lsmStatus === 2);
      const checkEnableForm =
        verifyLSM == 4 || verifyLSM == 5 || verifyLSM == 2;
      setEnableForm3(checkEnableForm);
    }
  }, [initialSteps, inBoundForm?.status]);

  const inboundFormPartAFieldsData = useMemo(
    () => [
      // SECTION A
      { section: `${phaseLabels.patient} & COLLECTION DETAILS` },
      {
        label: phaseLabels.hospital,
        type: "text",
        name: "hospital_name",
        placeholder: `Enter ${phaseLabels.hospital} Name`,
        disabled: true,
        noQuery: true,
        col: 2,
        isFirstPartField: true,
      },
      {
        label: `${phaseLabels.hospital}Patient ID`,
        type: "text",
        name: "hospital_patient_id",
        placeholder: `Enter ${phaseLabels.hospital}Patient ID`,
        required: true,
        disabled: true,
        noQuery: true,
        col: 4,
        isFirstPartField: true,
      },
      {
        label: `ImmunoACT ${phaseLabels.patient} ID`,
        type: "text",
        name: "immunoact_patient_id",
        placeholder: `Enter ImmunoACT ${phaseLabels.patient} ID`,
        disabled: true,
        noQuery: true,
        col: 4,
        isFirstPartField: true,
      },
      {
        label: `${phaseLabels.patient} Full Name`,
        type: "text",
        name: "full_name",
        placeholder: `Enter ${phaseLabels.patient} Full Name`,
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: `${phaseLabels.patient} Initials`,
        type: "text",
        name: "initials",
        placeholder: `Enter ${phaseLabels.patient} Initials`,
        noQuery: true,
        disabled: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Date of Birth",
        type: "date",
        name: "dob",
        placeholder: "Enter Date of Birth",
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Disease Indication",
        type: "text",
        name: "disease_indication",
        placeholder: "Enter Disease Indication",
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: `${phaseLabels.patient} Weight at Leukapheresis (kg)`,
        type: "number",
        name: "patient_weight",
        placeholder: `Enter ${phaseLabels.patient} Weight at Leukapheresis (kg)`,
        required: true,
        isResolve: ["editor"],
        col: 3,
        isFirstPartField: true,
      },

      // SECTION B
      { section: "SAMPLE TYPE & QUANTITY" },
      {
        label: "Sample Types",
        type: "checkbox",
        name: "sample_types",
        placeholder: "Select Sample Types",
        multiple: true,
        options: SampleTypes,
        required: true,
        isResolve: ["editor"],
        col: 2,
        isFirstPartField: true,
      },
      {
        label: "LSM Bag Quantity",
        type: "number",
        name: "lsm_bag_quantity",
        placeholder: "Enter LSM Bag Quantity",
        required: true,
        depend: "sample_types",
        dependValue: "fresh_lsm,cryo_lsm",
        disabled: true,
        max: 100,
        col: 2,
        noQuery: true,
        isFirstPartField: true,
      },
      {
        label: "Blood Tube Quantity",
        type: "number",
        name: "blood_tube_quantity",
        placeholder: "Enter Blood Tube Quantity",
        required: true,
        depend: "sample_types",
        dependValue: "blood_samples",
        col: 2,
        isResolve: ["editor"],
        isFirstPartField: true,
      },
      {
        label: "LSM Volumes per Bag",
        subLabel: "Enter LSM volumes for each bag",
        type: "textarea",
        name: "lsm_volumes",
        placeholder: "Enter LSM Volumes per Bag",
        disabled: false,
        manualValues: true,
        initialChildrenData: { bag_no: "", volume: "" },
        multipleField: true,
        hideDeleteIcon: true,
        isResolve: ["editor"],
        hideAddIcon: true,
        col: 3,
        max: 100,
        isFirstPartField: true,
        children: (index) => {
          return [
            {
              label: "  ",
              type: "checkbox",
              name: `lsm_volumes.${index}.blood_not_used`,
              multiple: false,
              required: false,
              noQuery: true,
              options: BloodNotUsed,
              col: 2,
              isFirstPartField: true,
            },
            {
              label: "Bag No",
              type: "number",
              name: `lsm_volumes.${index}.bag_no`,
              required: true,
              disabled: true,
              noQuery: true,
              placeholder: "Enter Bag No",
              manualError: true,
              isFirstPartField: true,
            },
            {
              label: "Volume (ml)",
              type: "number",
              name: `lsm_volumes.${index}.volume`,
              required: true,
              placeholder: "Enter Volume (ml)",
              noTransform: true,
              isFirstPartField: true,
            },
          ].filter(Boolean);
        },
      },
      {
        label: "Upload CBC report / ALC Count Report",
        type: "file",
        name: "sample_photo",
        placeholder: "Upload CBC report / ALC count report",
        col: 1,
        isResolve: ["editor"],
        isFirstPartField: true,
      },

      // SECTION C
      { section: "COLLECTION TIMING" },
      {
        label: "Date of Collection",
        type: "date",
        name: "collection_date",
        placeholder: "Select Collection Date",
        required: true,
        disabled: true,
        inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        noQuery: true,
        isResolve: ["editor"],
        isFirstPartField: true,
      },
      {
        label: "Start Time",
        type: "time",
        name: "start_time",
        placeholder: "Select Start Time",
        required: true,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        isResolve: ["editor"],
        isFirstPartField: true,
      },
      {
        label: "Stop Time",
        type: "time",
        name: "stop_time",
        placeholder: "Select Stop Time",
        required: true,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        isFirstPartField: true,
        isResolve: ["editor"],
      },

      // SECTION D
      { section: "DISPATCH DETAILS" },
      {
        label: "Mode of Dispatch",
        type: "select",
        name: "mode_of_dispatch",
        placeholder: "Select Mode of Dispatch",
        options: DispatchModes,
        required: true,
        col: 2,
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Logistics Partner",
        type: "select",
        name: "logistics_partner",
        placeholder: "Select Logistics Partner",
        required: true,
        options: LogisticsPartners,
        depend: "mode_of_dispatch",
        dependValue: "third_party",

        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Data Logger Used",
        type: "text",
        name: "data_logger_used",
        placeholder: "Enter Data Logger Used",
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Data Logger Serial No",
        type: "text",
        name: "data_logger_serial_no",
        placeholder: "Enter Data Logger Serial No",
      },
      {
        label: "Equipment ID",
        type: "select",
        name: "equipment_id",
        placeholder: "Select Equipment ID",
        options: equipmentOptions,
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Date of Dispatch",
        type: "date",
        name: "date_of_dispatch",
        placeholder: "Select Date of Dispatch",
        required: true,
        min: new Date(),
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Temperature at Dispatch (°C)",
        type: "number",
        name: "temperature_at_dispatch",
        placeholder: "Enter Temperature at Dispatch (°C)",
        isTempratureField: true,
        min: -80,
        max: 40,
        required: true,
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Time of Dispatch",
        type: "time",
        name: "time_of_dispatch",
        placeholder: "Select Time of Dispatch",
        required: true,
        col: 2,
        isFirstPartField: true,
        isResolve: ["editor"],
      },
      {
        label: "Upload Report/Log File",
        type: "file",
        name: "upload_report_log_file",
        placeholder: "Upload Report/Log File",
        col: 2,
        isFirstPartField: true,
      },
      {
        name: "alc",
        label: "ALC",
        type: "number",
        placeholder: "Enter ALC",
        required: true,
        extraContent: "× 10⁹ Cells",
        col: 2,
        isResolve: ["editor"],
      },
      {
        label: "Editor Name",
        type: "text",
        name: "editor_name",
        placeholder: "Enter Editor Name",
        disabled: true,
        noQuery: true,
        col: 2,
        isFirstPartField: true,
      },
      {
        label: "Declaration",
        type: "checkbox",
        name: "alc_declaration",
        placeholder: "Checked Declaration",
        multiple: false,
        required: true,
        depend: "showAlcDeclaration",
        dependValue: "1",
        options: ALCDelcarationOption,
        isResolve: ["editor"],
        col: 2,
        isFirstPartField: true,
      },
    ].filter((field) => !(isTrial && field.name === "full_name")),
    [
      patientData?.investigator?.hospital_details?.id,
      patientData?.id,
      patientData?.phase_type,
      isCommercial,
      isTrial,
    ],
  );

  const inboundFormPartBFieldsData = useMemo(
    () => [
      // SECTION E
      { section: "RECEIPT & VERIFICATION (IA Warehouse)" },
      {
        name: "date_of_receipt",
        label: "Date of Receipt",
        type: "date",
        required: true,
        placeholder: "Select Date of Receipt",
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "temperature_at_receipt",
        label: "Temperature at Receipt (°C)",
        type: "number",
        placeholder: "Enter Temperature at Receipt (°C)",
        required: true,
        isTempratureField: true,
        min: -80,
        max: 30,
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "time_of_receipt",
        label: "Time of Receipt",
        type: "time",
        required: true,
        placeholder: "Select Time of Receipt",
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "quantity_received",
        label: "No. of Bags",
        type: "number",
        placeholder: "Enter No. of Bags",
        required: true,
        // max: 5,
        notDecimal: true,
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "leakage",
        label: "Physical Check-Leakage",
        type: "radio",
        options: confirmationOptions,
        required: true,
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "leakage_comment",
        type: "textarea",
        label: "Check-Leakage 's Comment",
        depend: "leakage",
        dependValue: "true",
        noQuery: true,
        required: true,
        col: 2,
      },
      {
        name: "seal_broken",
        label: "Seal Broken",
        type: "radio",
        required: true,
        options: confirmationOptions,
        col: 2,

        isResolve: ["warehouse"],
      },
      {
        name: "seal_broken_comment",
        type: "textarea",
        label: "Seal Broken 's Comment",
        depend: "seal_broken",
        dependValue: "true",
        noQuery: true,
        required: true,
        col: 2,
      },
      {
        name: "transport_box_damaged",
        label: "Transport Box Damaged",
        type: "radio",
        required: true,
        options: confirmationOptions,
        col: 2,

        isResolve: ["warehouse"],
      },
      {
        name: "transport_box_damaged_comment",
        type: "textarea",
        label: "Transport Box Damaged 's Comment",
        depend: "transport_box_damaged",
        dependValue: "true",
        noQuery: true,
        required: true,
        col: 2,
      },
      {
        name: "receipt_photo",
        label: "Receipt Photo",
        type: "file",
        placeholder: "Upload Receipt Photo",
        col: 2,

        isResolve: ["warehouse"],
      },
      {
        name: "remarks",
        label: "Remarks",
        required: true,
        type: "textarea",
        placeholder: "Enter Remarks",
        max: 300,
        noQuery: true,
        col: 1,
      },
    ],
    [],
  );

  const inboundFormPartCFieldsData = useMemo(
    () => [
      // // SECTION F
      {
        section: "ALC REVIEW (IA QC ONLY)",
      },
      {
        name: "temperature_excursion",
        label: "Temperature Excursion",
        type: "radio",
        required: true,
        options: confirmationOptions,
        col: 2,
        isResolve: ["quality-check"],
      },
      {
        name: "temperature_excursion_comment",
        type: "textarea",
        label: "Temperature Excursion 's Comment",
        depend: "temperature_excursion",
        dependValue: "true",
        noQuery: true,
        required: true,
        col: 2,
      },
      {
        name: "excursion_time",
        label: "Excursion Time",
        type: "time",
        required: true,
        placeholder: "Select Excursion Time (00:00)",
        depend: "temperature_excursion",
        dependValue: "true",
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        isResolve: ["quality-check"],
      },
      {
        name: "excursion_temp",
        label: "Excursion Temperature (°C)",
        type: "number",
        required: true,
        placeholder: "Enter Excursion Temperature",
        depend: "temperature_excursion",
        dependValue: "true",
        isTempratureField: true,
        min: -80,
        max: 30,

        col: 3,
        isResolve: ["quality-check"],
      },
      {
        name: "excursion_duration",
        label: "Excursion Duration (HH:MM)",
        type: "time",
        required: true,
        placeholder: "e.g. 22:00",
        // pattern: "^\\d{1,3}:([0-5]\\d)$", // optional: use your form lib to validate
        depend: "temperature_excursion",
        dependValue: "true",
        col: 3,

        isResolve: ["quality-check"],
      },

      {
        name: "criteria_met",
        label: "ALC Criteria Met",
        type: "radio",
        options: confirmationOptions1,
        required: true,
        col: 2,
      },
      {
        name: "declaration_to_proceed",
        type: "text",
        label: "Comment",
        noQuery: true,
        placeholder: "Enter Comment",
        required: true,
        // noVisible: !isEditor,
        // required: true,
        col: 2,
      },
    ],
    [],
  );

  const inboundFormPartDFieldsData = useMemo(
    () => [
      // SECTION E
      { section: "Data Logger Files" },
      {
        name: "media_id",
        label: "Upload the Data Logger files",
        type: "file",
        placeholder: "Upload the Data Logger files",
        required: true,
        isResolve: ["logistics-management"],
      },
    ],
    [inBoundForm, LogisticsPartners],
  );

  const hasALCDataFilled = useMemo(() => {
    // Check if SECTION F (ALC Information) data is filled AND approved_by is not null
    const hasALCData =
      inBoundForm?.cd3_count ||
      inBoundForm?.criteria_met !== undefined ||
      inBoundForm?.criteria_met !== null ||
      inBoundForm?.declaration_to_proceed;
    const isApproved =
      inBoundForm?.approved_by !== null &&
      inBoundForm?.approved_by !== undefined;

    return hasALCData && isApproved;
  }, [inBoundForm]);

  const hasReviewedBy = useMemo(() => {
    // Check if reviewed_by is available from API
    return (
      inBoundForm?.reviewed_by !== null &&
      inBoundForm?.reviewed_by !== undefined
    );
  }, [inBoundForm]);

  const fieldsSet = useMemo(() => {
    // Check if ALC review form should be included (only if data is filled and approved)
    const includeALCForm = enableForm3 && hasALCDataFilled;

    // Part B is only shown when reviewed_by is available
    const includePartB = enableForm1 && enableForm2 && hasReviewedBy;

    if (
      enableForm1 &&
      enableForm2 &&
      enableForm4 &&
      includeALCForm &&
      hasReviewedBy
    ) {
      return [
        ...inboundFormPartAFieldsData,
        ...inboundFormPartDFieldsData,
        ...inboundFormPartBFieldsData,
        ...inboundFormPartCFieldsData,
      ];
    }
    if (enableForm1 && enableForm2 && enableForm4 && hasReviewedBy) {
      return [
        ...inboundFormPartAFieldsData,
        ...inboundFormPartDFieldsData,
        ...inboundFormPartBFieldsData,
      ];
    }
    if (includePartB) {
      return [...inboundFormPartAFieldsData, ...inboundFormPartBFieldsData];
    }
    if (enableForm1 && enableForm4) {
      return [...inboundFormPartAFieldsData, ...inboundFormPartDFieldsData];
    }
    if (enableForm1 || !enableForm4 || enableForm1 || !enableForm2) {
      return inboundFormPartAFieldsData;
    }
    return [];
  }, [
    enableForm1,
    enableForm3,
    enableForm2,
    enableForm4,
    hasALCDataFilled,
    hasReviewedBy,
    inboundFormPartAFieldsData,
    inboundFormPartCFieldsData,
    inboundFormPartBFieldsData,
    inboundFormPartDFieldsData,
  ]);

  const reactToPrintFnAll = useReactToPrint({
    content: () => printContentAllRef.current,
  });

  // console.log(patientData,'patientData132')

  // const handleFullPrint = (fields, values) => {
  //   setAllPrintData({ fields, values, state, title: "In-Bound Form" })
  //   printTimeoutAllRef.current = setTimeout(() => {
  //     reactToPrintFnAll();
  //     //   // Clear the timeout reference after execution
  //     printTimeoutAllRef.current = null;
  //   }, 100);
  // }

  const handleFullPrint = useCallback(() => {
    printTimeoutAllRef.current = setTimeout(() => {
      reactToPrintFnAll();
      printTimeoutAllRef.current = null;
    }, 100);
  }, [reactToPrintFnAll, patientData]);

  // const fetchFormDetails = (fields, values) => {
  //   // Prepare print data for preview only. Do not trigger the print dialog automatically.
  //   setAllPrintData({ fields, values, state, title: "In-Bound Form" })
  // }

  // Initial Values for Inbound Form Part A
  const partDInitialValues = useMemo(
    () => ({
      media_id: inBoundForm?.logger_media ? inBoundForm?.logger_media : null,
    }),
    [inBoundForm, patientData],
  );
  // console.log(inBoundForm,'inBoundForm')
  // Initial Values for Inbound Form Part A
  // Initial Values for Inbound Form Part A
  const partAInitialValues = useMemo(
    () => ({
      // SECTION A - Patient Demographics
      hospital_name:
        patientData?.hospital_details?.name ||
        inBoundForm?.hospital?.name ||
        patientData?.patient_information?.hospital ||
        "",
      hospital_patient_id: patientData?.hospital_patient_id || "",
      immunoact_patient_id:
        patientData?.subject_code ||
        inBoundForm?.patient?.subject_code ||
        patientData?.patient_information?.immunoact_patient_id ||
        "",
      full_name: patientData?.first_name
        ? `${capitalizeWords(patientData?.first_name)} ${capitalizeWords(
            patientData?.last_name,
          )}`
        : inBoundForm?.patient?.first_name || inBoundForm?.patient?.last_name
        ? `${capitalizeWords(inBoundForm?.patient?.first_name) ?? ""} ${
            capitalizeWords(inBoundForm?.patient?.last_name) ?? ""
          }`
        : patientData?.patient_information?.name || "",
      initials:
        patientData?.sub_initials ||
        inBoundForm?.patient?.sub_initials ||
        patientData?.patient_information?.patient_initials ||
        "",
      dob: patientData?.dob
        ? parseToDate(patientData?.dob)
        : inBoundForm?.patient?.dob
        ? parseToDate(inBoundForm?.patient?.dob)
        : patientData?.patient_information?.dob
        ? parseToDate(patientData?.patient_information?.dob)
        : "",
      disease_indication:
        capitalizeWords(patientData?.disease?.name) ||
        capitalizeWords(inBoundForm?.patient?.disease?.name) ||
        capitalizeWords(patientData?.patient_information?.disease) ||
        "",
      patient_weight: inBoundForm?.patient_weight
        ? inBoundForm?.patient_weight
        : patientData?.patient_information?.body_weight
        ? patientData?.patient_information?.body_weight
        : "",

      // SECTION B - Sample Information
      sample_types: inBoundForm?.sample_types
        ? Array.isArray(inBoundForm?.sample_types)
          ? inBoundForm.sample_types
          : JSON.parse(inBoundForm?.sample_types)
        : [],
      lsm_bag_quantity:
        inBoundForm?.lsm_bag_quantity || patientData?.number_of_bags || "",
      blood_tube_quantity: inBoundForm?.blood_tube_quantity ?? null,
      lsm_volumes: inBoundForm?.lsm_volumes
        ? inBoundForm?.lsm_volumes
        : Array.from(
            { length: patientData?.number_of_bags || 1 },
            (_, index) => ({
              bag_no: (index + 1).toString(), // Convert to string as per your requirement
              volume: "", // Empty string as per your requirement
              blood_not_used: [],
            }),
          ),

      sample_photo: inBoundForm?.samplePhoto
        ? [inBoundForm?.samplePhoto]
        : null,

      // SECTION C - Collection Timeline
      collection_date: inBoundForm?.collection_date
        ? new Date(inBoundForm?.collection_date)
        : new Date(),
      start_time: inBoundForm?.start_time
        ? inBoundForm?.start_time?.split(":").slice(0, 2).join(":")
        : "",
      stop_time: inBoundForm?.stop_time
        ? inBoundForm?.stop_time?.split(":").slice(0, 2).join(":")
        : "",
      // SECTION D - Dispatch Information
      mode_of_dispatch: inBoundForm?.mode_of_dispatch ?? "",
      logistics_partner: inBoundForm?.logistics_partner ?? "",
      data_logger_used: inBoundForm?.data_logger_used ?? "",
      data_logger_serial_no: inBoundForm?.data_logger_serial_no ?? "",
      equipment_id: inBoundForm?.equipment_id ?? "",
      date_of_dispatch: inBoundForm?.date_of_dispatch
        ? new Date(inBoundForm?.date_of_dispatch)
        : "",
      temperature_at_dispatch: inBoundForm?.temperature_at_dispatch ?? "",
      time_of_dispatch:
        Object.keys(inBoundForm)?.length > 0
          ? inBoundForm?.time_of_dispatch?.split(":").slice(0, 2).join(":")
          : timeString,
      upload_report_log_file: inBoundForm?.reportLogFile
        ? [inBoundForm?.reportLogFile]
        : null,
      editor_name: patientData?.editor?.name || inBoundForm?.editor_name || "",
      alc: inBoundForm?.alc ?? "",
      showAlcDeclaration: [inBoundForm?.alc_declaration] ?? [],
      alc_declaration: inBoundForm?.alc_declaration
        ? [inBoundForm?.alc_declaration]
        : [],
    }),
    [inBoundForm, patientData],
  );
  // Initial Values for Inbound Form Part B
  const partBInitialValues = {
    // SECTION E - Receipt Information
    date_of_receipt: !isNaN(Date.parse(inBoundForm?.date_of_receipt))
      ? new Date(inBoundForm?.date_of_receipt)
      : "",
    temperature_at_receipt: inBoundForm?.temperature_at_receipt ?? "",
    time_of_receipt: inBoundForm?.time_of_receipt ?? "",
    quantity_received: inBoundForm?.quantity_received ?? "",
    leakage: inBoundForm?.leakage ?? false,
    seal_broken: inBoundForm?.seal_broken ?? false,
    transport_box_damaged: inBoundForm?.transport_box_damaged ?? false,
    leakage_comment: inBoundForm?.leakage_comment ?? "",
    seal_broken_comment: inBoundForm?.seal_broken_comment ?? "",
    transport_box_damaged_comment:
      inBoundForm?.transport_box_damaged_comment ?? "",
    receipt_photo: inBoundForm?.receiptPhoto
      ? [inBoundForm?.receiptPhoto]
      : null,
    remarks: inBoundForm?.remarks ?? "",
  };
  // Initial Values for Inbound Form Part C
  const partCInitialValues = {
    // SECTION F - ALC Information & Declaration
    cd3_count: inBoundForm?.cd3_count ?? null,
    comment: inBoundForm?.comment ?? "",
    reason_id: inBoundForm?.reason ?? null,
    criteria_met:
      inBoundForm?.criteria_met == null || inBoundForm?.criteria_met ? 1 : 0,
    temperature_excursion_comment:
      inBoundForm?.temperature_excursion_comment ?? "",
    excursion_time: inBoundForm?.excursion_time ?? "",
    excursion_temp: inBoundForm?.excursion_temp ?? null,
    excursion_duration: inBoundForm?.excursion_duration ?? "",
    temperature_excursion: inBoundForm?.temperature_excursion ?? false,
    declaration_to_proceed: inBoundForm?.declaration_to_proceed ?? "",
  };

  const fetchInboundDetails = async () => {
    try {
      setIsLoading(true);
      const inBoundId = currentCycle?.inbond_patients_id;
      const res = await dispatch(
        fetchDetailsInBound({
          inBoundId,
          feasibility_assessments: currentCycle?.feasibility_assessments_id,
        }),
      );
      if (res?.payload?.status == 200) {
        const { lsm_volumes, sample_types } = res.payload.data;
        const transformedData = {
          ...res.payload.data,
          lsm_volumes: lsm_volumes ? JSON.parse(lsm_volumes) : [],
          sample_types: sample_types ? JSON.parse(sample_types) : [],
        };

        let data = transformDataWithFiles(transformedData);
        setInBoundForm(data);
      }
    } catch {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  //@info end here
  useEffect(() => {
    // Only fetch when at least one id is present; otherwise skip and show No Data Found

    fetchInboundDetails();
  }, [currentCycle]);

  const values = useMemo(() => {
    if (enableForm3)
      return {
        ...partAInitialValues,
        ...partDInitialValues,
        ...partBInitialValues,
        ...partCInitialValues,
      };
    if (enableForm2)
      return {
        ...partAInitialValues,
        ...partDInitialValues,
        ...partBInitialValues,
      };
    if (enableForm4) return { ...partAInitialValues, ...partDInitialValues };
    if (enableForm1) return partAInitialValues;
    return {};
  }, [
    enableForm1,
    enableForm2,
    enableForm4,
    partAInitialValues,
    partBInitialValues,
    partCInitialValues,
    partDInitialValues,
    inBoundForm,
  ]);

  useEffect(() => {
    if (!inBoundForm || !Object.keys(inBoundForm).length) return;

    setAllPrintData({
      fields: fieldsSet,
      values,
      printPatientInfo: patientData,
      title: "In-Bound Form",
    });
  }, [inBoundForm, patientData]); // ✅ stable dependency

  return (
    <>
      {/* PRIMARY CONDITION */}
      {/* {!inBoundId && !feasibilityId && (
        <div>No Data Found</div>
      )} */}

      {/* INBOUND PRINT */}
      {currentCycle?.inbond_patients_id ? (
        // &&
        // inBoundId && feasibilityId
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <LoadingButton
              type="button"
              size="small"
              onClick={handleFullPrint}
              className="!w-[100px] "
            >
              Print
            </LoadingButton>
          </Box>
          {allPrintData && (
            <>
              {isLoading ? (
                <SkeletonLoader
                  rowCount={2}
                  height={130}
                  // width={140}
                  isTable={false}
                />
              ) : (
                <div>
                  <QrAllPrintContent
                    ref={printContentAllRef}
                    printData={{
                      ...allPrintData,
                      inbound_submit_at: inBoundForm?.submitted_on ?? "",
                      inbound_submit_by: inBoundForm?.submitted_by ?? "",
                      inbound_created_on: inBoundForm?.created_on ?? "",
                    }}
                    type="inbound"
                  />
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <div>
          <NoDataCard heading="No Data to Display" />
        </div>
      )}
    </>
  );
};

export default DownloadInboundForm;
